export default "/build/images/dark.png?b220d1991d8d76df18103fcdd0b138d6";